import { inject, Injectable, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '../../../../state/storage/storage.action';
import { StoreService } from '../store/store.service';

@Injectable({ providedIn: 'root' })
export class SyncStorageService {
    private listenerFnUnsub: () => void;

    // Injectors
    private renderer: Renderer2; // Can't inject renderer in a service, so we have to pass it from the component
    private readonly router: Router = inject(Router);
    private readonly store: StoreService = inject(StoreService);

    public init({
        renderer,
        storeKeyPrefix,
        withLogout
    }: {
        renderer: Renderer2;
        storeKeyPrefix: string;
        withLogout?: boolean;
    }): void {
        this.renderer = renderer;
        if (withLogout) this.syncStorageWithLogout(storeKeyPrefix);
        else this.syncStorage(storeKeyPrefix);
    }

    private syncStorageWithLogout(storeKeyPrefix: string): void {
        const logoutKeys: string[] = ['token', 'oauth', 'authentication'];
        this.listenerFnUnsub = this.renderer.listen('window', 'storage', event => {
            if (event.key?.startsWith(storeKeyPrefix)) {
                // Triggered by tab where logout was triggered setting the empty initial states again
                const deserializedKey: string = this.deserialize(event.key, storeKeyPrefix);
                if (logoutKeys.includes(deserializedKey) && !event.oldValue) {
                    // Navigate to logout to clear this tab's store
                    this.router.navigateByUrl('/logout').then(r => {
                        if (!r) {
                            console.warn('Logout failed');
                        }
                    });
                } else {
                    this.store.dispatch(new Storage(deserializedKey));
                }
            }
        });
    }

    private syncStorage(storeKeyPrefix: string): void {
        this.listenerFnUnsub = this.renderer.listen('window', 'storage', event => {
            if (event.key?.startsWith(storeKeyPrefix)) {
                const deserializedKey: string = this.deserialize(event.key, storeKeyPrefix);
                this.store.dispatch(new Storage(deserializedKey));
            }
        });
    }

    private deserialize(key: string, prefix: string): string {
        return key.replace(`${prefix}_`, '');
    }

    public destroy(): void {
        this.listenerFnUnsub();
    }
}
